/** @format */
import {
  ICartItem,
  ModernPromotionResponse,
  PlpPromoMessages,
  ProductPromotionCollection,
  ProductPromotionResponse,
  ProductVO,
  PromoDetailsMap,
  PromotionDetailsMapV1,
  PromotionDetailsMapV2,
} from '@shared/data-access/interfaces';
import { Injectable, inject } from '@angular/core';
import { Observable, map, of } from 'rxjs';

import { DiscountEligibilityDao } from './discount-eligibility.dao';
import { DiscountId } from '@shared/data-access/enums';

@Injectable({
  providedIn: 'root',
})
export class DiscountEligibilityService {
  private readonly discountDao = inject(DiscountEligibilityDao);

  // Modern returns "<ProductPromotionResponse[]>"
  public getPromoList$(
    productList: ProductVO[] | ICartItem[],
  ): Observable<ProductPromotionCollection | ProductPromotionResponse[]> {
    // New plp endpoint using ecodes instead of catentryIds
    return this.discountDao.getModernProductPromoList(productList);
  }

  public getPromoDescription$(
    checkoutKey?: string,
    promotionId?: number,
    discountId?: string,
  ): Observable<string> {
    return discountId === DiscountId.RWD
      ? of(DiscountId.RWDMESSAGE)
      : // And this is the getLongDescription already being used in modern already
        this.discountDao
          .getLongDescription(discountId)
          .pipe(map((response) => response?.longMessage ?? ''));
  }

  public getPromoMessage$(ecode: string, sku?: string) {
    return this.discountDao.getPromoMessage(ecode, sku);
  }

  public getItemLevelPromoDescription$(
    ecode?: string,
    sku?: string | string[],
  ): Observable<PromotionDetailsMapV1 | PromotionDetailsMapV2 | ModernPromotionResponse | null> {
    return this.discountDao.getPromoMessage(ecode, sku);
  }

  public generatePromoMessages(
    promo: ProductPromotionResponse[] | ProductPromotionCollection | null,
  ): PlpPromoMessages | PromoDetailsMap | null {
    if (!promo) {
      return null;
    }

    const promoMessages = {};

    if (Array.isArray(promo)) {
      promo.forEach((promoItem) => {
        promoMessages[promoItem.ecode] = promoItem.promoMessages;
      });

      return promoMessages;
    }

    return promo.data.promoDetailsMap;
  }
}
